import { render, staticRenderFns } from "./RecipientTags.vue?vue&type=template&id=6aea2584&scoped=true"
import script from "./RecipientTags.vue?vue&type=script&lang=ts"
export * from "./RecipientTags.vue?vue&type=script&lang=ts"
import style0 from "./RecipientTags.vue?vue&type=style&index=0&id=6aea2584&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aea2584",
  null
  
)

export default component.exports